import { FacebookIcon, InstagramIcon, LinkedInIcon } from "@/assets/svgs/icons";

export const CURRENT_YEAR = new Date().getFullYear();

export const SOLUTIONS = [
  "Feedback Forms",
  "Queries",
  "Public Consultations",
  "Customer Reviews",
  "Market Research Surveys",
  "Staff Surveys",
  "Snap Polls",
  "Job Application Forms",
  "Complaint Forms",
  "Brand Engagement",
  "Academic Research",
];

export const SOCIAL_LINKS = [
  {
    href: "https://www.facebook.com/people/Unzippd/61578727628456/",
    icon: FacebookIcon,
    label: "Facebook",
  },
  {
    href: "https://www.instagram.com/_unzippd",
    icon: InstagramIcon,
    label: "Instagram",
  },
  {
    href: "https://www.linkedin.com/company/unzippd/",
    icon: LinkedInIcon,
    label: "LinkedIn",
  },
];

export const CYBER_ESSENTIALS_EMBED = `<a href="https://registry.blockmarktech.com/certificates/078ff8dd-5af2-4362-bf8e-89394afab118/active/?source=email"><img alt="Cyber Essentials logo" src="https://registry.blockmarktech.com/certificates/078ff8dd-5af2-4362-bf8e-89394afab118/email-image/?width=120&height=120" width="120" height="120" oncontextmenu="return false;"/></a>`;
